import { FileStatus, type UploadedImage } from '@/lib/types';
import { Report as ErrorIconFilled } from '@mui/icons-material';
import { useState } from 'react';
import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import FormattedHtmlMessage from '@/components/FormattedHtmlMessage';
import {
  StyledErrorIcon,
  ErrorMessage,
  StyledDialogTitle,
} from './styled-components';

type ImageErrorStateProps = {
  image: UploadedImage;
};

const ImageErrorState = ({ image }: ImageErrorStateProps) => {
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const variant =
    image.file.status === FileStatus.INAPPROPRIATE_CONTENT_DETECTED
      ? 'inappropriate_content'
      : 'malware';

  return (
    <>
      <StyledErrorIcon />
      <ErrorMessage onClick={() => setInfoDialogOpen(true)}>
        <FormattedMessage
          id={`portfolio.challenge.files.uploaded_image.error_state.messages.${variant}`}
        />
      </ErrorMessage>
      <Dialog
        open={infoDialogOpen}
        onClose={() => setInfoDialogOpen(false)}
        dangerous
      >
        <StyledDialogTitle>
          <ErrorIconFilled />
          <FormattedMessage
            id={`portfolio.challenge.files.uploaded_image.error_state.info_dialogs.${variant}.title`}
          />
        </StyledDialogTitle>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedHtmlMessage
              id={`portfolio.challenge.files.uploaded_image.error_state.info_dialogs.${variant}.text`}
              values={{
                imageFilename: image.file.originalFilename,
              }}
            />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.DeleteButton onClick={() => setInfoDialogOpen(false)}>
            <FormattedMessage id="dialogs.actions.done" />
          </Dialog.Actions.DeleteButton>
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default ImageErrorState;
